export default __webpack_public_path__ + "static/media/044-hose.f8982ba4.png";